import { Col, Divider, Row, theme } from 'antd';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import BarChart from '../../../../components/DashboardPage/BarChart';
import InfoBox from '../../../../components/DashboardPage/InfoBox';
import { generateReportQueryStringFromQuery } from '../TicketReport/TicketReportFiltersContainer';

const CallReportItemsContainer = () => {
    const {
        token: { marginMD }
    } = theme.useToken();

    const { query } = useRouter();
    const { t } = useTranslation('reports');
    const queryString = generateReportQueryStringFromQuery(query);
    return (
        <>
            <Row style={{ justifyContent: 'space-evenly' }} gutter={[marginMD / 2, marginMD / 2]}>
                <InfoBox
                    url={queryString ? `/reports/call/total-call-count?${queryString}` : null}
                    title={t('callReports.reportItems.totalCountOfCall')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/total-call-duration?${queryString}` : null}
                    title={t('callReports.reportItems.totalDurationOfCall')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/average-call-duration?${queryString}` : null}
                    title={t('callReports.reportItems.totalAverageOfTalkDuration')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/total-agents-hangs-up-count?${queryString}` : null}
                    title={t('callReports.reportItems.totalNumberOfCallsEndedByAgent')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/total-on-hold-call-duration?${queryString}` : null}
                    title={t('callReports.reportItems.totalOnHoldDuration')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/total-call-efficiency?${queryString}` : null}
                    title={t('callReports.reportItems.efficiencyPerformance')}
                />
            </Row>
            <Divider />
            <Row style={{ justifyContent: 'space-evenly' }}>
                <Col span={20}>
                    <BarChart
                        url={queryString ? `/reports/call/call-count-per-hour?${queryString}` : null}
                        title={t('callReports.reportItems.numberOfIncomingCallsPerHour')}
                    />
                </Col>
            </Row>
            <Divider />
            <Row style={{ justifyContent: 'space-evenly' }} gutter={[marginMD / 2, marginMD / 2]}>
                <InfoBox
                    url={queryString ? `/reports/call/inbound-call-count?${queryString}` : null}
                    title={t('callReports.reportItems.numberOfIncoming')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/answered-call-count?${queryString}` : null}
                    title={t('callReports.reportItems.numberOfAnsweredIncoming')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/total-inbound-call-duration?${queryString}` : null}
                    title={t('callReports.reportItems.incomingCallTalkTime')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/average-inbound-call-duration?${queryString}` : null}
                    title={t('callReports.reportItems.incomingCallAverageTalkTime')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/total-agents-hangs-up-inbound-calls-count?${queryString}` : null}
                    title={t('callReports.reportItems.numberOfIncomingCallsEndedByAgent')}
                />
            </Row>
            {/* <Divider />
            <Row justify="space-evenly" style={{ gap: '10px 10px', marginTop: '10px' }}>
                <InfoBox
                    url={ queryString ?`/reports/call/response-speed?${queryString}` : null}
                    title={t('callReports.reportItems.responseSpeed')}
                />
                <InfoBox
                    url={ queryString ?`/reports/call/time-in-ivr?${queryString}` : null}
                    title={t('callReports.reportItems.timeInIVR')}
                />
            </Row> */}
            <Divider />
            <Row style={{ justifyContent: 'space-evenly' }} gutter={[marginMD / 2, marginMD / 2]}>
                <InfoBox
                    url={queryString ? `/reports/call/outbound-call-count?${queryString}` : null}
                    title={t('callReports.reportItems.numberOfOutboundCalls')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/answered-outbound-call-count?${queryString}` : null}
                    title={t('callReports.reportItems.numberOfAnsweredOutboundCalls')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/total-outbound-call-duration?${queryString}` : null}
                    title={t('callReports.reportItems.outboundCallTalkTime')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/average-outbound-call-duration?${queryString}` : null}
                    title={t('callReports.reportItems.outboundCallAverageTalkTime')}
                />
                <InfoBox
                    url={queryString ? `/reports/call/total-agents-hangs-up-outbound-calls-count?${queryString}` : null}
                    title={t('callReports.reportItems.numberOfOutboundCallsEndedByAgent')}
                />
            </Row>
            <Divider />
        </>
    );
};

export default CallReportItemsContainer;
